import LandscapeLabelImage from './images/landscape-label.svg';
import LandscapePackingSlipImage from './images/landscape-packing-slip.svg';
import PortraitLabelImage from './images/portrait-label.svg';
import PortraitPackingSlipImage from './images/portrait-packing-slip.svg';
import { messages } from './messages';

/**
 * @typedef {import('../../../prop-types/intl').MessageDescriptorPropType} MessageDescriptorPropType
 */

/**
 * @typedef {object} ImageVariant
 * @property {JSX.Element} portrait
 * @property {JSX.Element} landscape
 */

/**
 * @typedef {object} ImageType
 * @property {MessageDescriptorPropType} text
 * @property {ImageVariant} image
 */

/**
 * @typedef {object} ImageTypes
 * @property {ImageType} Label
 * @property {ImageType} PackingSlip
 */

export const ImageTypes = {
  Label: {
    text: messages.label,
    image: {
      portrait: PortraitLabelImage,
      landscape: LandscapeLabelImage,
    },
  },
  PackingSlip: {
    text: messages.packingSlip,
    image: {
      portrait: PortraitPackingSlipImage,
      landscape: LandscapePackingSlipImage,
    },
  },
};
